import _ from 'lodash';
import { AD_GROUP, LDAP_GROUP, REQUEST_TYPE, PRIVILEGED } from './constant';

export const getMultipleAddMemberPayload = ({ order }) => {
    const groupType = order?.groupType;
    return {
        businessApplication: order?.businessApplication,
        environment: order?.environment,
        sector: order?.sector,
        requestType: order?.typeOfRequest,
        modifyRequestType: 'addmembers',
        applicationOwner: {
            id: order?.appOwnerDetails?.gpid,
            emailId: order?.appOwnerDetails?.email,
            name: order?.appOwnerDetails?.name,
        },
        groups: (order?.multipleAdGroups || []).map((adGroupObj) => ({
            groupType,
            isPrivileged: adGroupObj?.adGroupType === 'Privileged',
            groupName: adGroupObj?.adGroup,
            groupOwner: adGroupObj?.adGroupOwner?.gpid || '',
            domainType: order?.domainType,
            newGroup: false,
            members: (adGroupObj?.members || []).map((m) => m?.gpid),
            ...(adGroupObj?.adGroupType === 'Privileged' && {
                secondaryAccountDetails: (adGroupObj?.members || [])
                    ?.filter((m) => m?.secondaryAccount)
                    ?.map((m) => ({
                        memberGPID: m?.gpid,
                        accountDetails: [
                            {
                                secondaryAccountName: m?.secondaryAccount?.secondaryAccountName,
                                requestInfo: m?.secondaryAccount?.requestInfo,
                                userPrincipalName: m?.secondaryAccount?.userPrincipalName,
                            },
                        ],
                    })),
            }),
        })),
    };
};
export const getAdGroupNewMembershipPayload = ({ order }) => {
    return {
        businessApplication: order?.businessApplication,
        environment: order?.environment,
        sector: order?.sector,
        requestType: order?.typeOfRequest,
        applicationOwner: {
            id: order?.appOwnerDetails?.gpid,
            emailId: order?.appOwnerDetails?.email,
            name: order?.appOwnerDetails?.name,
        },
        groups: (order?.multipleResourceGroups || []).map((resourceGroup) => ({
            groupType: order?.groupType,
            groupCategory: resourceGroup?.groupCategory,
            groupSubCategory: resourceGroup?.groupSubCategoryDetails?.label,
            domainType: resourceGroup?.domainType,
            isPrivileged: resourceGroup?.activeDirectoryGroupType === PRIVILEGED,
            groupName: resourceGroup?.groupName,
            groupOwner: resourceGroup?.groupOwnerDetails?.gpid,
            newGroup: true,
            members: (resourceGroup?.members || []).map((m) => m?.gpid),
            ...(resourceGroup?.activeDirectoryGroupType === PRIVILEGED && {
                secondaryAccountDetails: (resourceGroup?.members || [])
                    ?.filter((m) => m?.secondaryAccount)
                    ?.map((m) => ({
                        memberGPID: m?.gpid,
                        accountDetails: [
                            {
                                secondaryAccountName: m?.secondaryAccount?.secondaryAccountName,
                                requestInfo: m?.secondaryAccount?.requestInfo,
                                userPrincipalName: m?.secondaryAccount?.userPrincipalName,
                            },
                        ],
                    })),
            }),
        })),
    };
};
export const getAdGroupOwnerChangePayload = ({ order }) => {
    return {
        businessApplication: order?.businessApplication,
        environment: order?.environment,
        sector: order?.sector,
        requestType: 'Modify',
        modifyRequestType: 'changeownership',
        applicationOwner: {
            id: order?.appOwnerDetails?.gpid,
            emailId: order?.appOwnerDetails?.email,
            name: order?.appOwnerDetails?.name,
        },
        groups: [
            {
                groupType: 'Active Directory Group',
                isPrivileged: order?.adGroupType === 'Privileged',
                groupName: order?.adGroup,
                groupOwner: order?.adGroupOwnerGpid,
                newGroupOwner: order?.groupOwnerDetails?.gpid,
                newGroup: false,
            },
        ],
    };
};
export const getAddMemberPayload = ({ order, members }) => {
    const newArray = members?.map((obj) => {
        return _.omit(obj, ['label']);
    });

    const getMembers = (arr) => {
        const result = [];
        const pamsafeGPids = order?.mypamsafeDetails?.map((pam) => pam?.safeOwner);
        const getsafename = (safeobj) => order?.mypamsafeDetails?.filter((pam) => pam?.safeOwner === safeobj?.gpid)?.[0]?.safeName;

        arr?.map((obj) => {
            if (order?.mypamsafeDetails?.length > 0) {
                if (pamsafeGPids?.includes(obj?.gpid)) {
                    const mergedobj = { ...obj, safeName: getsafename(obj) };
                    result?.push(mergedobj);
                } else if (result?.length > 0 && result.some((res) => res?.gpid !== obj?.gpid)) {
                    const mergedobj = { ...obj, safeName: 'SAFE NOT AVAILABLE' };
                    result?.push(mergedobj);
                } else if (result?.length === 0 && result.some((res) => res?.gpid !== obj?.gpid)) {
                    const mergedobj = { ...obj, safeName: 'SAFE NOT AVAILABLE' };
                    result?.push(mergedobj);
                } else {
                    const mergedobj = { ...obj, safeName: 'SAFE NOT AVAILABLE' };
                    result?.push(mergedobj);
                }
            } else {
                const mergedobj = { ...obj, safeName: 'SAFE NOT AVAILABLE' };
                result?.push(mergedobj);
            }
            return '';
        });
        return result;
    };

    return {
        businessApplication: order?.businessApplication,
        environment: order?.environment,
        sector: order?.sector,
        applicationOwner: order?.appOwnerDetails?.gpid,
        groupType: order?.groupType,

        // Handling AD Group
        ...(order?.typeOfRequest === REQUEST_TYPE.MODIFY &&
            order?.groupType === AD_GROUP && {
                adGroup: order?.adGroup,
            }),

        // Handling LDAP Group
        ...(order?.typeOfRequest === REQUEST_TYPE.MODIFY &&
            order?.groupType === LDAP_GROUP && {
                ldapGroup: order?.adGroup,
            }),

        // New AD/LDAP Group flags
        newADGroup: order?.typeOfRequest === REQUEST_TYPE.NEW && order?.groupType === AD_GROUP,
        newLDAPGroup: order?.typeOfRequest === REQUEST_TYPE.NEW && order?.groupType === LDAP_GROUP,

        // AD Group specific details (when it's a new AD Group)
        ...(order?.groupType === AD_GROUP &&
            order?.typeOfRequest === REQUEST_TYPE.NEW && {
                applicationShortName: order?.appShortName,
                groupOwner: {
                    gpid: order?.groupOwnerDetails?.gpid,
                    email: order?.groupOwnerDetails?.email,
                    name: order?.groupOwnerDetails?.name,
                },
                adGroupType: order?.adGroupTypeDetails?.value,
                applicationName: order?.applicationName,
                applicationService: order?.appService,
            }),

        // LDAP Group specific details (when it's a new LDAP Group)
        ...(order?.groupType === LDAP_GROUP &&
            order?.typeOfRequest === REQUEST_TYPE.NEW && {
                project: order?.projectName,
                applicationService: order?.appService,
                groupOwner: {
                    gpid: order?.groupOwnerDetails?.gpid,
                    email: order?.groupOwnerDetails?.email,
                    name: order?.groupOwnerDetails?.name,
                },
            }),

        // Members based on group type
        members: order?.adGroupType === 'Privileged' ? getMembers(newArray) : newArray,
    };
};

export const getRemoveMemberPayload = ({ order }) => {
    // Payload structure for removing members from a group
    return {
        businessApplication: order?.businessApplication,
        environment: order?.environment,
        sector: order?.sector,
        requestType: order?.typeOfRequest,
        modifyRequestType: 'removemembers',
        applicationOwner: {
            id: order?.appOwnerDetails?.gpid,
            emailId: order?.appOwnerDetails?.email,
            name: order?.appOwnerDetails?.name,
        },
        groups: [
            {
                groupType: 'Active Directory Group',
                groupName: order?.adGroup,
                groupOwner: order?.adGroupDetails?.[0]?.adgroupOwnerId || '',
                newGroup: false,
                domainType: order?.domainType,
                isPrivileged: order?.adGroupDetails?.[0]?.adgroupType === 'Privileged',
                members: (order?.membersToRemove || [])?.map((group) => group?.gpid),
            },
        ],
    };
};
export const getDisableGroupPayload = ({ order }) => {
    return {
        businessApplication: order?.businessApplication,
        environment: order?.environment,
        sector: order?.sector,
        requestType: 'disableGroups',
        applicationOwner: {
            id: order?.appOwnerDetails?.gpid,
            emailId: order?.appOwnerDetails?.email,
            name: order?.appOwnerDetails?.name,
        },
        groups: (order?.adGroupListForDisable || []).map((group) => ({
            groupType: 'Active Directory Group',
            groupName: group?.adGroup,
            groupOwner: group?.adGroupOwner?.split('-')?.[0] || '',
            newGroup: false,
            isPrivileged: group?.adgroupType === 'Privileged',
            members: group?.members?.map((mem) => mem?.gpid),
        })),
    };
};

export const getDay2ResubmitRequestPayload = ({ order }) => {
    const catalog = order?.catalogServices?.[0]?.catalogConfig;
    const payload = {
        ...(catalog?.adGroup && {
            adGroup: catalog?.adGroup,
        }),
        ...(catalog?.groupType && {
            groupType: catalog?.groupType,
        }),
        ...(catalog?.ldapGroup && {
            ldapGroup: catalog?.ldapGroup,
        }),
        ...(catalog?.applicationShortName && {
            applicationShortName: catalog?.applicationShortName,
        }),
        ...(catalog?.groupOwner && {
            groupOwner: catalog?.groupOwner,
        }),
        ...(catalog?.adGroupType && {
            adGroupType: catalog?.adGroupType,
        }),
        ...(catalog?.applicationName && {
            applicationName: catalog?.applicationName,
        }),
        ...(catalog?.applicationService && {
            applicationService: catalog?.applicationService,
        }),
        ...(catalog?.project && {
            project: catalog?.project,
        }),
        ...(catalog?.applicationOwner && {
            applicationOwner: catalog?.applicationOwner,
        }),
        newADGroup: catalog?.newADGroup,
        newLDAPGroup: catalog?.newLDAPGroup,
        businessApplication: catalog?.businessApplication,
        environment: catalog?.environment,
        sector: catalog?.sector,
        members: catalog?.members,
    };
    return payload;
};

export const formOrderObjFromOrderDetails = (data = null) => {
    if (data?.catalogServices?.[0]?.catalogConfig) {
        const response = data?.catalogServices?.[0]?.catalogConfig;
        const getPamsafedetails = (resmembers) => {
            const safeRes = resmembers?.filter((mem) => mem?.safeName !== 'SAFE NOT AVAILABLE');
            const result = safeRes?.map((safemem) => ({ safeOwner: safemem?.gpid, safeName: safemem?.safeName }));
            return result;
        };
        const getnonSafeDetails = (safemembers) => {
            const res = safemembers?.filter((mem) => mem?.safeName === 'SAFE NOT AVAILABLE');
            return res?.map((mems) => mems?.gpid);
        };
        return {
            appOwner: null,
            appOwnerDetails: { name: data?.manager?.name, gpid: data?.manager?.id },
            businessApplication: response?.businessApplication,
            sector: response?.sector,
            environment: response?.environment,
            members: response?.members,
            adGroupType: response?.adGroupType,
            groupType: response?.groupType,
            ...(response?.adGroupType === 'Privileged' && {
                mypamsafeDetails: getPamsafedetails(response?.members),
                nonSafeDetailsGpid: getnonSafeDetails(response?.members),
            }),
            ...(response?.adGroupType !== 'Privileged' && {
                mypamsafeDetails: [],
                nonSafeDetailsGpid: [],
            }),
            ...((response?.adGroup || response?.ldapGroup) && {
                adGroup: response?.adGroup || response?.ldapGroup,
            }),
            domainType: response?.domainType || null,
            modifyRequestType: response?.modifyRequestType || null,
            ...(response?.groupType === AD_GROUP && {
                typeOfRequest: response?.newADGroup === true ? REQUEST_TYPE.NEW : REQUEST_TYPE.MODIFY,
            }),
            ...(response?.groupType === LDAP_GROUP && {
                typeOfRequest: response?.newLDAPGroup === true ? REQUEST_TYPE.NEW : REQUEST_TYPE.MODIFY,
            }),
            ...(response?.newADGroup === true &&
                response?.groupType === AD_GROUP && {
                    adGroupType: response?.adGroupType,
                    appShortName: response?.applicationShortName,
                    groupOwnerDetails: { name: response?.groupOwner?.name },
                    adGroupTypeDetails: { value: response?.adGroupType },
                    applicationName: response?.applicationName,
                    appService: response?.applicationService,
                }),
            ...(response?.newLDAPGroup === true &&
                response?.groupType === LDAP_GROUP && {
                    projectName: response?.project,
                    appService: response?.applicationService,
                    groupOwnerDetails: { name: response?.groupOwner?.name },
                }),
            isTouched: false,
        };
    }
    return null;
};
export const costPayload = ({ order = {}, catalogServiceId, day2Catalog }) => {
    const payload = {
        ...(catalogServiceId && { catalogServiceId }),
        cloudProvider: day2Catalog?.[0]?.cloudProvider,
        cloudService: day2Catalog?.[0]?.cloudService,
        catalogServiceCode: day2Catalog?.[0]?.catalogDefinitionId,
        catalogType: day2Catalog?.[0]?.catalogType,
        sector: order?.sector,
        quantity: 1,
        catalogConfig: {
            safeMemberCount: order?.nonSafeDetailsGpid?.length,
            isPrivileged: order?.adGroupType === 'Privileged',
        },
    };

    return payload;
};
